import { render, staticRenderFns } from "./card_and_car.vue?vue&type=template&id=5acbaea9"
import script from "./card_and_car.vue?vue&type=script&lang=js"
export * from "./card_and_car.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports